<template>
  <div class="autocomplete">
    <b-input-group>
      <b-form-input
          autocomplete="off"
          v-model="query"
          :placeholder="placeholder"
          @input="queryChanged"
          @blur="blurred()"
          @click="clickEvent"
          class="borderful"
          :class="inputClass"
          :required="required"
          :state="state"
      />
      <b-input-group-append>
        <b-button variant="info" @click="queryChanged" v-if="buttonVisible">Хайх</b-button>
      </b-input-group-append>
    </b-input-group>
    <div class="options" v-if="visible">
      <ul v-if="items.length" class="border">
        <li v-for="(item, i) in items"
            class="no-select"
            :key=i
            @click="itemClicked(item)"
            v-text="listValue(item)"
        />
      </ul>
      <ul v-else class="border">
        <li
            class="no-select"
            @click="itemClicked('')"
            v-text="'Илэрц олдсонгүй'"
        />
      </ul>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';

export default {
  name: 'auto-complete',
  props: {
    items: {
      required: true,
    },
    buttonVisible: {
      type: Boolean,
      required: false,
      default: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    displayValue: {
      type: String,
      required: false,
      default: '',
    },
    inputClass: {
      type: String,
      required: false,
      default: '',
    },
    state: {
      type: Boolean,
      required: false,
      default: null,
    },
    isBrand: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      query: '',
      visible: false,
      childState: true,
    };
  },
  watch: {
    query(val) {
      if (val) {
        this.$emit('query', this.query);
      } else {
        this.$emit('query', '');
        this.$emit('selected', null);
      }
    },
  },
  created() {
    this.blurred = _.debounce(this.blurred, 200);
  },
  methods: {
    listValue(item) {
      if (this.isBrand) return this.displayValue ? `${this.toSymbolName(item[this.displayValue])} | ${item.company_name}` : item;
      return this.displayValue ? item[this.displayValue] : item;
    },
    clickEvent() {
      this.$emit('click');
      this.visible = true;
    },
    queryChanged() {
      this.$emit('query');
      this.visible = true;
    },
    itemClicked(match) {
      if (match) {
        this.query = this.displayValue ? match[this.displayValue] : match;
        this.$emit('selected', match);
      } else {
        this.query = '';
        this.$emit('selected', '');
      }
      this.visible = false;
    },
    blurred() {
      this.$emit('blur');
      this.visible = false;
    },
  },
};
</script>
<style scoped>
  .autocomplete {
    width: 100%;
    position: relative;
  }
  .popover input{
    width: 95%;
    margin-top: 5px;
    height: 40px;
    font-size: 16px;
    border-radius: 3px;
    border:1px solid lightgray;
    padding-left: 8px;
  }
  .options{
    max-height: 150px;
    width: 100%;
    overflow-y: scroll;
    margin-top: 5px;
    border-radius: 5px;
    position: absolute;
    z-index: 999;
    scrollbar-width: thin;
    scrollbar-color: #90A4AE #CFD8DC;
  }

  .options::-webkit-scrollbar {
    width: 11px;
  }
  .options::-webkit-scrollbar-track {
    background: #CFD8DC;
  }
  .options::-webkit-scrollbar-thumb {
    background-color: #90A4AE ;
    border-radius: 6px;
    border: 3px solid #CFD8DC;
  }

  .options ul {
    /*list-style-type: none;*/
    text-align: left;
    padding-left: 0;
  }
  .options ul li {
    border: 1px lightgray;
    padding: 10px;
    cursor: pointer;
    background: #f1f1f1;
  }
  .options ul li:hover {
    background: #58bd4c;
    color: #fff;
    font-weight: 600;
  }
  .borderful {
    /* TODO: !important арилгаж ном журмын дагуу css ашиглах */
    border-radius: 0.25rem !important;
  }
</style>
